webpackJsonp([215574658652148],{

/***/ 499:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>This is a hand-coded website. For the last few years, I have recreated my website using intriguing new technologies as a means of stretching my skills.</p>\n<p>If you’re into design, this one is responsive by design, and utilizes TypeKit to provide the slab serif Museo Sans, among other faces. Excluding normalize, it does not use a design framework, but instead relies upon my eye for design and a bit of Fibonacci as a guide for layout.</p>\n<p>If you’re deep into technology, this site is a static React.js website based on Gatsby. Because it’s just as easy for me to edit a website by hand as via using a CMS, this one is static.</p>\n<p>If you’re into both design and technology, drop me a line as there aren’t many of us out there. We should grab a pint.</p>","frontmatter":{"slug":"colophon","title":"Colophon"}}},"pathContext":{"slug":"colophon"}}

/***/ })

});


// WEBPACK FOOTER //
// path---colophon-e853a531d8fb97b599b7.js